import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

import {
	ParallelAiMonitorFrequency,
	ParallelAiMonitorProcessor,
	ParallelAiType,
} from "@/enum/parallel-ai-type.enum";

const { REQUIRED } = ERROR_TYPE;

export const ParallelAiSchema = z.object({
	id: z.number(),
	query: z.string().min(3, { message: REQUIRED }).trim(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	type: z.nativeEnum(ParallelAiType).optional(),
	frequency: z.nativeEnum(ParallelAiMonitorFrequency).nullish(),
	processor: z.nativeEnum(ParallelAiMonitorProcessor).nullish(),
	location: z.string().nullish(),
	monitorId: z.string().nullish(),
	monitorStatus: z.string().nullish(),
});

export const ParallelAiEnrichmentResultSchema = z.object({
	id: z.number(),
	organizationId: z.number().nullable(),
	prospectId: z.number().nullable(),
	results: z.string().nullable(),
	aiEnrichment: ParallelAiSchema,
});

export const CreateParallelAiSchema = z.object({
	id: z.number().optional(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	query: z.string().min(2, { message: REQUIRED }).trim(),
	listId: z.number().optional(),
	type: z.nativeEnum(ParallelAiType).optional(),
	frequency: z.nativeEnum(ParallelAiMonitorFrequency).nullish(),
	processor: z.nativeEnum(ParallelAiMonitorProcessor).nullish(),
	location: z.string().nullish(),
});

export const ParallelAiResponseSchema = z.object({
	data: z.array(ParallelAiSchema),
	meta: MetaDataSchema,
});

export const ParallelAiTriggerResponseSchema = z.object({
	message: z.string(),
});

export type ParallelAi = z.infer<typeof ParallelAiSchema>;

export type CreateParallelAi = z.infer<typeof CreateParallelAiSchema>;

export type ParallelAiResponse = z.infer<typeof ParallelAiResponseSchema>;

export type ParallelAiTriggerResponse = z.infer<typeof ParallelAiTriggerResponseSchema>;
